import React from 'react';
import AdUnit from '../AdUnit';

const HeaderAd = () => (
  <div role="complementary" aria-label="Header advertisement">
    <AdUnit
      adSlot="8356274141"
      adFormat="horizontal"
    />
  </div>
);

export default HeaderAd;
